import { memo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import DevicePairingWizard from '../components/DevicePairingWizard.jsx'

/**
 * Device Pairing Page Component
 * Route handler for /add-device that opens the DevicePairingWizard
 * Supports pre-populating serial number from URL parameters
 */
const DevicePairingPage = memo(() => {
  const [isOpen, setIsOpen] = useState(true)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  
  const serialNumber = searchParams.get('serial')
  
  const handleClose = () => {
    setIsOpen(false)
    // Navigate back to home after closing
    navigate('/')
  }
  
  return (
    <DevicePairingWizard 
      isOpen={isOpen}
      onClose={handleClose}
      initialSerialNumber={serialNumber}
    />
  )
})

DevicePairingPage.displayName = 'DevicePairingPage'

export default DevicePairingPage
